<button
  [attr.form]="formId"
  [attr.type]="buttonType">
  <mg-icon *ngIf="icon; else ws">{{ icon }}</mg-icon>
  <ng-content></ng-content>
  <ng-template #ws>&nbsp;</ng-template>
</button>
